import React from 'react';
import images from '../../themes/appImage'
import appconstants from '../../themes/appconstant';

const Instruction = () => {
    return (
        <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between  ">
            <div className='max-w-[424px] max-h-[455px]  flex items-center flex-col mt-5  px-3  '>
                <img className=" mb-5 " src={images.appLogo} alt="metafit-logo" />
                <div className='w-full bg-white border shadow-metafit-shadow rounded-lg p-6 md:p-2 sm:w-[100vw] '>
                    <div className='flex items-center justify-center mt-3'>


                        <div className='w-20 h-20 bg-royalPurple rounded-full flex justify-center items-center'>
                            <img src={images.lock} alt="password" />
                        </div>

                    </div>
                    <div className='text-2xl font-semibold text-dark text-center mt-8 mb-1'>{appconstants.instructionSent}</div>
                    <div>
                        <div className="text-sm text-center text-gray60  ">{appconstants.instructionText1}</div>
                        {/* <div className="text-sm text-center text-gray60 mb-5">{appconstants.instructionText2}</div> */}
                    </div>

                </div>
                <div className="text-sm text-dark mt-8 ">{appconstants.metafitRights}</div>
            </div>

        </div>
    );
}

export default Instruction;
